import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinkhradi() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Kharadi',
    heading: 'Aaryan Travels: Corporate Cab Services in Kharadi',
    headingDescription: ' Aaryan Travels provides dependable Corporate Cab Services in Kharadi, catering to IT professionals, business executives, and corporate offices located in major hubs like EON IT Park and World Trade Center. Whether you require daily staff commute, client pickups, airport transfers, or intercity corporate travel, our fleet of sedans, SUVs, and luxury vehicles ensures a smooth and professional transportation experience. With uniformed chauffeurs, GPS-enabled cars, monthly billing options, and 24/7 availability, we offer reliable mobility solutions tailored to corporate standards. From office-to-office transfers to long-distance business trips, Aaryan Travels is the trusted choice for corporate cab services in Kharadi.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


"services": [
  {
    "name": "Corporate Cab Services in Kharadi Pune",
    "description": "Our Corporate Cab Services in Kharadi Pune are designed to cater specifically to the transportation needs of businesses and professionals. Whether it’s daily employee commutes, client visits, or corporate events, we provide a reliable and efficient fleet of vehicles including sedans and SUVs. Our service emphasizes punctuality, professionalism, and safety, with well-maintained cars and experienced chauffeurs who understand the corporate landscape of Kharadi."
  },
  {
    "name": "Business Taxi Kharadi Pune",
    "description": "The Business Taxi service in Kharadi Pune offers flexible and affordable taxi options for corporate clients. Ideal for executives, staff transportation, or client pickups, our taxis are available round the clock with easy booking options. Enjoy clean, comfortable rides and professional drivers who prioritize your time and convenience."
  },
  {
    "name": "Cab Booking Kharadi Pune",
    "description": "Easily book cabs in Kharadi Pune through our seamless Cab Booking platform. Whether you need rides for daily office commutes or business meetings, our service guarantees quick confirmations, multiple vehicle options, and professional drivers. Designed for efficiency, this service helps you manage your corporate travel without any hassle."
  },
  {
    "name": "Kharadi Office Cab Services",
    "description": "Kharadi Office Cab Services provide dedicated transport solutions for companies looking to streamline employee travel. We offer fixed-route and flexible scheduling options with comfortable vehicles and trained drivers. This service is perfect for large teams, shift workers, and businesses aiming to enhance employee punctuality and comfort."
  },
  {
    "name": "Chauffeur Driven Corporate Cabs Kharadi",
    "description": "Experience premium travel with our Chauffeur Driven Corporate Cabs in Kharadi. Tailored for executives and business visitors, our service includes luxury sedans and SUVs driven by professional chauffeurs who ensure safe, comfortable, and timely rides. Whether it’s airport transfers or inter-office travel, enjoy a stress-free journey with our expert drivers."
  },
  {
    "name": "Monthly Corporate Cab Kharadi",
    "description": "Our Monthly Corporate Cab service in Kharadi offers businesses a cost-effective and reliable transportation solution for long-term employee commute needs. With fixed monthly contracts, companies can ensure consistent availability of vehicles with professional drivers, flexible routes, and transparent billing, making daily travel management simple and efficient."
  },
  {
    "name": "Kharadi Staff Transport",
    "description": "Designed for businesses of all sizes, our Kharadi Staff Transport service focuses on safe, punctual, and comfortable rides for employees. We accommodate various shift timings, provide multi-seater vehicles, and use GPS tracking to ensure timely pickups and drop-offs, helping companies improve workforce productivity and satisfaction."
  },
  {
    "name": "Kharadi Sedan Cab Hire",
    "description": "Hire premium sedans in Kharadi for corporate travel needs. Our Sedan Cab Hire service provides stylish, comfortable vehicles ideal for executives, client meetings, and business events. All cars are well-maintained, air-conditioned, and driven by courteous, experienced chauffeurs for a professional travel experience."
  },
  {
    "name": "SUV Hire for Corporates Kharadi",
    "description": "Our SUV Hire service for corporates in Kharadi is perfect for groups requiring spacious, luxurious transport. Whether for team outings, client transfers, or airport pickups, these SUVs offer extra comfort and style. Enjoy professional drivers, flexible booking, and top-quality vehicles to match your corporate standards."
  },
  {
    "name": "Kharadi Business Travel Cabs",
    "description": "Kharadi Business Travel Cabs provide a seamless travel experience for business professionals. From daily commutes to intercity trips, our service offers reliable, comfortable, and timely rides with a focus on customer convenience and safety. Flexible booking and a wide range of vehicles cater to all corporate travel needs."
  },
  {
    "name": "Affordable Cab Kharadi Pune",
    "description": "Get the best value for your corporate travel budget with our Affordable Cab service in Kharadi Pune. Offering competitive rates without compromising on comfort or safety, this service is ideal for businesses looking to optimize their transportation costs while maintaining high service standards."
  },
  {
    "name": "Employee Travel Cab Kharadi Pune",
    "description": "Ensure your employees travel comfortably and punctually with our Employee Travel Cab service in Kharadi Pune. Tailored to meet daily commute requirements, shift timings, and special event transport, our service enhances employee satisfaction with professional drivers and reliable vehicles."
  },
  {
    "name": "Top Corporate Cab Kharadi Pune",
    "description": "Ranked among the top corporate cab services in Kharadi Pune, we pride ourselves on delivering excellent service quality, modern fleet, and customer-focused solutions. From executive transport to employee shuttling, we provide dependable and professional travel options tailored to business needs."
  },
  {
    "name": "Kharadi Company Cabs",
    "description": "Kharadi Company Cabs offer dedicated vehicle services for businesses looking for organized employee transportation. With customized routes, flexible timing, and a focus on safety and comfort, our company cabs ensure smooth daily operations and help businesses maintain punctuality."
  },
  {
    "name": "Kharadi Corporate Car Hire",
    "description": "Our Corporate Car Hire service in Kharadi offers an extensive fleet of sedans and SUVs for short-term or long-term business use. Perfect for client meetings, corporate events, and executive travel, these cars come with professional chauffeurs, flexible packages, and reliable service to meet all corporate transportation demands."
  }
],
"tableData": [
  ["Corporate Cab Services in Kharadi Pune", "Business Taxi Kharadi Pune"],
  ["Cab Booking Kharadi Pune", "Kharadi Office Cab Services"],
  ["Chauffeur Driven Corporate Cabs Kharadi", "Monthly Corporate Cab Kharadi"],
  ["Kharadi Staff Transport", "Kharadi Sedan Cab Hire"],
  ["SUV Hire for Corporates Kharadi", "Kharadi Business Travel Cabs"],
  ["Affordable Cab Kharadi Pune", "Employee Travel Cab Kharadi Pune"],
  ["Top Corporate Cab Kharadi Pune", "Kharadi Company Cabs"],
  ["Kharadi Corporate Car Hire", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Professional Corporate Cab Services in Kharadi",
    "WhyChoosedescription": "Aaryan Travels offers reliable and timely corporate cab services tailored for businesses in Kharadi."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop for Office Commutes",
    "WhyChoosedescription": "Ensure hassle-free daily commutes for your employees with our punctual and efficient cab services."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Business-Class Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed to provide a comfortable and professional travel experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Kharadi’s Corporate Routes",
    "WhyChoosedescription": "Our drivers know Kharadi’s IT parks and business hubs for smooth and timely navigation."
  },
  {
    "WhyChooseheading": "Transparent Corporate Billing with No Hidden Costs",
    "WhyChoosedescription": "Get clear, GST-compliant invoices and all-inclusive pricing with no surprise charges."
  },
  {
    "WhyChooseheading": "24/7 Support for Business Travel Needs",
    "WhyChoosedescription": "Our dedicated customer support team is available round the clock to assist with corporate bookings and coordination."
  },
  {
    "WhyChooseheading": "Flexible Contract Options: Daily, Weekly or Monthly",
    "WhyChoosedescription": "Choose from short-term or long-term cab hire contracts tailored to your organization’s needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Corporate Requirement",
    "WhyChoosedescription": "From sedans to SUVs and tempo travellers, select the right vehicle for executives, staff, or client travel."
  }
]
























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab services in Kharadi?',
    answer: 'Yes, Aaryan Travels provides professional and reliable corporate cab services in Kharadi to cater to business travel needs.',
  },
  {
    question: 'How can I book corporate cab services in Kharadi with Aaryan Travels?',
    answer: 'You can book corporate cabs through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Kharadi?',
    answer: 'Aaryan Travels offers a fleet of sedans, SUVs, and premium cars suitable for executive and employee transportation in Kharadi.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cab services suitable for daily employee commute in Kharadi?',
    answer: 'Yes, we offer customized corporate cab solutions for daily employee pickups and drops in Kharadi.',
  },
  {
    question: 'Are drivers experienced and trained for corporate travel requirements in Kharadi?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and familiar with Kharadi and its corporate travel standards.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group cab bookings for corporate events in Kharadi?',
    answer: 'Yes, we specialize in managing group transportation and bulk cab bookings for corporate meetings and events in Kharadi.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for corporate cab services in Kharadi?',
    answer: 'Yes, we provide flexible billing options including monthly invoicing for corporate clients in Kharadi.',
  },
  {
    question: 'Is your corporate cab service in Kharadi available 24x7?',
    answer: 'Yes, Aaryan Travels offers 24x7 corporate cab services to ensure seamless business travel in Kharadi.',
  },
  {
    question: 'What safety measures are in place for corporate cab services in Kharadi?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings in Kharadi?',
    answer: 'Yes, we allow full customization of pickup and drop points based on your corporate travel requirements in Kharadi.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Abhishek Deshmukh',
    feedback: 'Aaryan Travels’ corporate cab service in Kharadi is punctual, professional, and perfect for our company’s daily commute.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Reliable corporate cab services by Aaryan Travels in Kharadi. Great support and timely service.',
    rating: 5,
  },
];























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Kharadi, Pune",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-kharadi-pune.jpg", // replace with actual image URL
  "description": "Reliable and affordable corporate cab services in Kharadi, Pune by Aaryan Travels. Perfect for business travel, staff transport, and office commutes with sedan and SUV options. Book your corporate cab online today.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update if needed
    "ratingCount": "2300", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-services-kharadi-pune"
  }
};







  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in Kharadi | Business Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable corporate cab services in Kharadi, Pune by Aaryan Travels. Perfect for business travel, staff transport, and office commutes with sedan and SUV options. Book your corporate cab online today."
  />
  <meta
    name="keywords"
    content="Corporate Cab Services in Kharadi Pune, Business Taxi Kharadi Pune, Cab Booking Kharadi Pune, Kharadi Office Cab Services, Chauffeur Driven Corporate Cabs Kharadi, Monthly Corporate Cab Kharadi, Kharadi Staff Transport, Kharadi Sedan Cab Hire, SUV Hire for Corporates Kharadi, Kharadi Business Travel Cabs, Affordable Cab Kharadi Pune, Employee Travel Cab Kharadi Pune, Top Corporate Cab Kharadi Pune, Kharadi Company Cabs, Kharadi Corporate Car Hire"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinkhradi;